export const extractKeysFromDicitionary = (
  dict: Localisation.CsvFileContent,
  keyPrefix: string
) =>
  Object.keys(dict)
    .filter((el) => el.startsWith(keyPrefix))
    .map((el) => dict[el]);
